export default __webpack_public_path__ + "static/media/seeMore.2fd515dc.svg";